import api from "./api";

export const iibbService = {
  getStatus() {
    return api.get("/iibb/status").then(r => r.data);
  },
  uploadPadron(province, file) {
    const formData = new FormData();
    formData.append("province", province);
    formData.append("file", file);
    return api.post("/iibb/upload", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }).then(r => r.data);
  }
};
